<div class="container pt-3">
  @if (form) {
    <app-form [form]="form" [isPreview]="false"/>
  }
</div>

